import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFab } from "@/components/layout/WhatsAppFab";

export const SiteLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#FFFFFF] text-[#1A1B2E]" style={{ fontFamily: "'Outfit', sans-serif" }}>
    <Navbar />
    <main className="flex-1" data-testid="page-main">
      {children}
    </main>
    <Footer />
    <WhatsAppFab />
  </div>
);
